var _path, _g, _rect, _rect2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_38037)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_38037",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 54,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8655 5.66003L54.5356 22.3302L21.4127 55.4531L2.90765 58.9195C1.94146 59.1005 1.09514 58.2542 1.27613 57.288L4.74254 38.783L37.8655 5.66003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_38037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4707 3.0553L57.1409 19.7254L22.0463 54.82L2.92453 58.9323C1.93224 59.1457 1.05043 58.2639 1.26383 57.2716L5.37615 38.1498L40.4707 3.0553Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5537,
    y: 17.6417,
    width: 11.7876,
    height: 41.9932,
    transform: "rotate(45 42.5537 17.6417)",
    fill: "#F1C800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59403 36.806L17.028 43.1678L23.3898 56.6018L10.2558 69.7358L-9.54002 49.94L3.59403 36.806Z",
    fill: "#FFF2B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.878174,
    y: 46.8145,
    width: 17.6814,
    height: 9.5774,
    transform: "rotate(45 0.878174 46.8145)",
    fill: "#363636"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.1582,
    y: -0.591431,
    width: 22.1017,
    height: 18.4181,
    rx: 2.79603,
    transform: "rotate(45 45.1582 -0.591431)",
    fill: "#FFAFAF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3862,
    y: 4.09705,
    width: 25.0486,
    height: 14.7345,
    rx: 1.39802,
    transform: "rotate(45 38.3862 4.09705)",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.364286,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3977 8.21133C37.9436 7.66537 38.8288 7.66537 39.3748 8.21132L41.5652 10.4018C42.1112 10.9477 42.1112 11.8329 41.5652 12.3789L36.2491 17.695C35.7032 18.2409 34.818 18.2409 34.272 17.695L32.0816 15.5045C31.5356 14.9586 31.5356 14.0734 32.0816 13.5274L37.3977 8.21133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_38037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.569aaaa55df762f6828dfb0dd2855170.svg";
export { ForwardRef as ReactComponent };